import { useId } from "react";

export const Logo = ({ dark = true, className = "" }) => {
  const gid = useId();
  return (
    <span className={`flex flex-col items-center ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 84 28" className="h-6 w-auto mb-1" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#C9920E" />
            <stop offset="50%" stopColor="#F5D67B" />
            <stop offset="100%" stopColor="#D4AF37" />
          </linearGradient>
        </defs>
        <path
          d="M3 15 L42 4 L81 15"
          stroke={`url(#${gid})`}
          strokeWidth="4.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="37.6" y="17" width="4" height="4" rx="0.8" fill={`url(#${gid})`} />
        <rect x="42.8" y="17" width="4" height="4" rx="0.8" fill={`url(#${gid})`} />
        <rect x="37.6" y="22.2" width="4" height="4" rx="0.8" fill={`url(#${gid})`} />
        <rect x="42.8" y="22.2" width="4" height="4" rx="0.8" fill={`url(#${gid})`} />
      </svg>
      <span className="font-heading leading-none text-[28px] font-black tracking-[0.06em] whitespace-nowrap">
        <span className={dark ? "text-zinc-900" : "text-white"}>SAFE</span>
        <span className="text-gold-luxury">HOME</span>
      </span>
      <span
        className={`flex w-full justify-between text-[10px] uppercase font-bold mt-1.5 ${
          dark ? "text-zinc-600" : "text-white/70"
        }`}
        aria-label="Security Solutions"
      >
        {"SECURITY SOLUTIONS".split("").map((c, i) => (
          <span key={i}>{c === " " ? "\u00A0" : c}</span>
        ))}
      </span>
    </span>
  );
};
